import Layout from './Layout';
//import DynamicDataGridComponent from '../components/DynamicDataGrid.js'
import Box from '@mui/material/Box';
import {useLiveStockHook} from '../hook/LiveStockHook.js'
import { lazy } from 'react';
import  Bindcomponent  from '../utils/bindcomponent.js';
import GridNumberPaging from '../components/GridNumberPaging.js'
import { json } from 'react-router-dom';
import { Suspense, useCallback, useEffect, useState } from 'react';
import StringToReactComponent from 'string-to-react-component';
// import DataGridComponent from '../components/DynamicDataGrid.js';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';

// project import
 

export default function LiveStock() {
    //const {rows,message,setmessage,columns,comp} = useLiveStockHook();
    const hook = useLiveStockHook();
    //console.log(hook)
    const {rows, message, setmessage, columns, component, value} = hook;
    // console.log(comp)
    const [props, setProps] =  useState({})
   console.log(value)
    
    const handleComponent = () => {
        let obj = {}
        
        for(let key in  component){
            for(let key2 in hook){
             
                if(component[key].toString().replace('{','').replace('}','') == key2){
                    if(obj.hasOwnProperty(key)==false){
                        Object.defineProperty(obj, key, {value:hook[key2],enumerable:true},);
                    }
                } 
            }

            if(obj.hasOwnProperty(key)==false){
                Object.defineProperty(obj, key, {value:component[key],enumerable:true});
            }
        }
   
          if(Object.getOwnPropertyNames(obj).length > 0){
                setProps(obj)
          }
      
    } 
   
    useEffect(()=>{
        handleComponent();
    },[rows])
    
    return ( 
        <>
            <Layout message={message} setmessage={setmessage}>
                  
                <div className='pd' ><b>PRODUCT LIVE STOCK</b></div>
                <div className="pd">
                    <Box sx={{ height: "100%" }} >
                            {/* <StringToReactComponent data={{Bindcomponent, props, component:'GridNumberPaging'}}>
                                {`(props)=>{
                                    return (<>
                                        <props.Bindcomponent component={props.component} props={props.props} /> 
                                    </>)
                            }`}
                            </StringToReactComponent> */}
                             {/* <Bindcomponent component='GridNumberPaging' props={props}></Bindcomponent>   */}
                      
                            <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"livestockgrid"} rowid="rowNumber"></Bindcomponent>  
                        {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"livestockgrid"} rowid="rowNumber"  ></GridNumberPaging> */}
                        
                    </Box>
                </div>
              
            </Layout>
        </>
         
    )
}

